import { useEffect, useState } from 'react';

const WhatsAppButton = () => {
  const [pulse, setPulse] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setPulse(true);
      setTimeout(() => setPulse(false), 600);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <a
      href="https://wa.me/17542034748"
      target="_blank"
      rel="nofollow noreferrer"
      aria-label="Hablar por WhatsApp"
      className={`fixed bottom-6 left-6 z-50 w-16 h-16 flex items-center justify-center bg-[#25D366] rounded-full shadow-2xl cursor-pointer transition-transform duration-200 hover:scale-110 ${
        pulse ? 'scale-110' : 'scale-100'
      }`}
    >
      <i className="ri-whatsapp-line text-white text-3xl"></i>
    </a>
  );
};

export default WhatsAppButton;
